import { render, staticRenderFns } from "./RegionManagerInfo.vue?vue&type=template&id=404ac08a&"
import script from "./RegionManagerInfo.vue?vue&type=script&lang=js&"
export * from "./RegionManagerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports